import React, { Component } from 'react';
import Inbox from './Inbox.js';

export default class InboxTelaahanStaf extends Component {
  render() {
    return (
      <Inbox type='TNDE_TELAAHAN_STAF'/>
    );
  }
}
